var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{ref:"threeCanvas",staticClass:"three-canvas",class:{'pointer-cursor': _vm.cursorIsPointer, 'in-foreground': _vm.inForeground, 'on-the-side': _vm.detailsPanelConcept !== null},on:{"touchmove":function($event){$event.preventDefault();_vm.preventEvent($event)}}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-03ae4977","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/molecules/TotemCanvas.vue
// module id = 851
// module chunks = 1